import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import { alpha } from "@material-ui/core/styles";
import EmojiNature from "@material-ui/icons/EmojiNature";
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Avatar from "@material-ui/core/Avatar";
import { useRef, useState } from "react";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";

import { getAll } from "src/api/vendorServices";
import { Main } from "src/components/commons/Main";
import { VendorServiceForm } from "src/components/vendorServices/Form";
import Table from "src/components/commons/Table/Table";
import StatusChip from "src/components/commons/StatusChip";

const statusMap = { IN_PROGRESS: "In Progress", ACTIVE: "Active", INACTIVE: "Inactive", PENDING: "Pending" };

const useStyles = makeStyles((theme) => ({
	emptyState: {
		padding: "6rem 0",
		color: alpha(theme.palette.common.black, 0.3),
	},
	avatar: {
		width: 40,
		height: 40,
		background: theme.palette.background.default,
		"& img": {
			objectFit: "contain",
		},
	},
	modal: {
		transform: "translate(-50%, -50%)",
	},
}));

export function VendorServices() {
	const { state } = useLocation();
	const navigate = useNavigate();
	const paginatedServices = useLoaderData();
	const classes = useStyles();
	const [openFormModal, setOpenFormModal] = useState(state?.create || false);
	const selectedService = useRef(null);

	const columns = [
		{
			header: 'Services',
			accessor: 'name',
			render: (value, row) => (
				<Box display="flex" alignItems="center">
					<Avatar
						className={classes.avatar}
						variant="rounded"
						alt={row.name}
						src="/images/icons/campaign.svg"
					/>
					<Box ml={2}>
						<Typography variant="body1">{row.name}</Typography>
						<Typography variant="body2" color="textSecondary">
							{row.description}
						</Typography>
					</Box>
				</Box>
			)
		},
		{
			header: 'Status',
			accessor: 'status',
			align: 'center',
			render: (value) => (
				<StatusChip status={statusMap[value]} />
			)
		},
		{
			header: 'Action',
			accessor: 'id',
			align: 'right',
			render: (value, row) => (
				<Box>
					<Button
						startIcon={<Edit />}
						style={{ marginRight: "0.5rem" }}
						color="primary"
						size="small"
						variant="contained"
						onClick={() => {
							selectedService.current = row;
							setOpenFormModal(true);
						}}
					>
						Edit Service Name
					</Button>
					<Button
						startIcon={<Edit />}
						color="primary"
						size="small"
						variant="contained"
						onClick={() => navigate(`/service/${row.id}/details`)}
					>
						Edit Service Details
					</Button>
				</Box>
			)
		}
	];

	return (
		<Main>
			<Box display={"flex"} justifyContent="space-between" p={4} px={4} borderBottom={"1px solid rgb(239 232 251)"}>
				<Typography component={"h2"} variant="h6">
					Services/Products
				</Typography>
				<Box>
					<Button
						startIcon={<Add />}
						color="primary"
						size="small"
						variant="contained"
						onClick={() => setOpenFormModal(true)}
					>
						Add New Service
					</Button>
				</Box>
			</Box>
			{paginatedServices.data.length === 0 ? (
				<Box textAlign={"center"} className={classes.emptyState}>
					<Box>
						<EmojiNature />
					</Box>
					You don&apos;t have any services so far{" "}
					<Button
						variant="text"
						color="primary"
						disabled={false}
						startIcon={<Add />}
						onClick={() => setOpenFormModal(true)}
					>
						Create One
					</Button>
				</Box>
			) : (
				<Box p={4}>
					<Table
						columns={columns}
						data={paginatedServices.data}
						loading={false}
						error={false}
						page={0}
						rowsPerPage={10}
						totalCount={paginatedServices.data.length}
						onPageChange={() => {}}
						onRowsPerPageChange={() => {}}
						getRowId={(row) => row.id}
						className="border-0 shadow-none"
						stickyHeader
					/>
				</Box>
			)}
			<Dialog
				fullWidth={true}
				maxWidth="xs"
				open={openFormModal}
				onClose={() => setOpenFormModal(false)}
				arialabelledby={"form-vs-dialog"}
			>
				<DialogTitle id="form-vs-dialog" pb={0}>
					Service/Product Details
				</DialogTitle>
				<VendorServiceForm vendorService={selectedService.current} close={() => setOpenFormModal(false)} />
			</Dialog>
		</Main>
	);
}

export function vendorServicesLoader() {
	return getAll();
}
